var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 56,
    viewBox: "0 0 32 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2270_1263)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2270_1263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29176 36.4696V38.4401C6.29176 40.4118 8.81942 41.2256 9.96971 39.6242L13.0864 35.2856C13.4678 34.7547 14.0813 34.44 14.7348 34.44H29.4292C30.5501 34.44 31.4588 33.5314 31.4588 32.4105V13.2854C31.4588 12.1645 30.5501 11.2558 29.4292 11.2558H2.0296C0.908681 11.2558 0 12.1645 0 13.2854V32.4105C0 33.5314 0.908681 34.44 2.0296 34.44H4.26215C5.38307 34.44 6.29176 35.3487 6.29176 36.4696Z",
    fill: "#F45600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43555 17.319H24.467",
    stroke: "white",
    strokeWidth: 1.34439,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57031 21.8895H18.0142",
    stroke: "white",
    strokeWidth: 1.34439,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57031 26.7297H22.0474",
    stroke: "white",
    strokeWidth: 1.34439,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2270_1263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2270_1263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33.4884,
    fill: "white",
    transform: "translate(0 11.2558)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.dc078a993f4a2f34667098605e9cf4a0.svg";
export { ForwardRef as ReactComponent };